import { DismissablePromptType, DismissablePromptsClientsVariables } from '@ms/yammer-graphql';
import queryDismissablePrompts from '@ms/yammer-graphql/dist/operations/queryDismissablePrompts.graphql';

import { GraphqlApiRequest, ManagedApiLifecycle, getGraphqlApiRequest, managedApiAction } from '../..';
import { normalizeDismissablePromptsByTypeResponse } from '../../normalization/graphql/normalizeDismissablePromptByType';
import { DismissablePromptsByTypeResponse } from '../../normalization/types';
import { DismissablePromptByType } from '../../state/types';
import { reportError } from '../../telemetry';
import { PromiseThunkAction } from '../../types';

import {
  DismissPromptByTypeUpdateAction,
  LoadDismissablePromptsByTypeFulfilledAction,
  LoadDismissablePromptsByTypePendingAction,
  LoadDismissablePromptsByTypeRejectedAction,
} from './actions.types';

export const updateDismissPromptByType = (promptType: DismissablePromptType): DismissPromptByTypeUpdateAction => ({
  type: 'DISMISSABLE_PROMPTS_BY_TYPE.DISMISS_PROMPT_FULFILLED',
  payload: {
    promptType,
  },
});

const loadDismissablePromptsByTypePending = (
  promptTypes: DismissablePromptType[]
): LoadDismissablePromptsByTypePendingAction => ({
  type: 'DISMISSABLE_PROMPTS_BY_TYPE.LOAD_PENDING',
  payload: {
    promptTypes,
  },
});

const loadDismissablePromptsByTypeFulfilled = (
  entities: Record<string, DismissablePromptByType>
): LoadDismissablePromptsByTypeFulfilledAction => ({
  type: 'DISMISSABLE_PROMPTS_BY_TYPE.LOAD_FULFILLED',
  payload: {
    entities,
  },
});

const loadDismissablePromptsByTypeRejected = (
  promptTypes: DismissablePromptType[],
  error: unknown
): LoadDismissablePromptsByTypeRejectedAction => ({
  type: 'DISMISSABLE_PROMPTS_BY_TYPE.LOAD_REJECTED',
  payload: {
    promptTypes,
    error,
  },
  error: true,
});

const loadDismissablePromptsByTypeRequest = (
  promptTypes: DismissablePromptType[]
): GraphqlApiRequest<DismissablePromptsClientsVariables> =>
  getGraphqlApiRequest({
    body: {
      operationName: 'DismissablePromptsClients',
      query: queryDismissablePrompts,
      variables: {
        promptTypes,
      },
    },
  });

const loadDismissablePromptsByTypeLifecycle = (
  promptTypes: DismissablePromptType[]
): ManagedApiLifecycle<DismissablePromptsByTypeResponse> => ({
  pending: () => loadDismissablePromptsByTypePending(promptTypes),
  fulfilled: (response) => loadDismissablePromptsByTypeFulfilled(normalizeDismissablePromptsByTypeResponse(response)),
  rejected: (error) => loadDismissablePromptsByTypeRejected(promptTypes, error),
});

export type LoadDismissablePrompts = (promptTypes: DismissablePromptType[]) => PromiseThunkAction<void>;
export const loadDismissablePromptsByType: LoadDismissablePrompts = (promptTypes) => async (dispatch) => {
  const request = loadDismissablePromptsByTypeRequest(promptTypes);
  const lifecycle = loadDismissablePromptsByTypeLifecycle(promptTypes);
  const action = managedApiAction({ request, lifecycle });

  try {
    await dispatch(action);
  } catch (error) {
    reportError({ error });
  }
};
